import { Stack, Typography } from "@mui/material";

import { ReactNode } from "react";

interface IInfo {
  title: ReactNode;
  value: string | number;
}

const Info: React.FC<IInfo> = ({ title, value }) => {
  return (
    <Stack spacing={1} sx={{ flex: 1 }}>
      <Typography sx={{ fontSize: 14, color: "grey.600" }}>{title}</Typography>
      <Typography sx={{ fontSize: 16 }}>{!value ? "-" : value}</Typography>
    </Stack>
  );
};

export default Info;
